import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";

import { createRoot } from "react-dom/client";
import { v4 as uuidv4 } from "uuid";

import "./assets/scss/_app.scss";
import "tippy.js/dist/tippy.css";

import { initializeSentry } from "./config/sentry";
import axios from "axios";

import App from "./App";

import {
  PointElement,
  LinearScale,
  CategoryScale,
  Chart,
  LineElement,
} from "chart.js";
Chart.register(CategoryScale);
Chart.register(LinearScale);
Chart.register(PointElement);
Chart.register(LineElement);

// Initialize Sentry with the axios default instance for interceptor configuration
initializeSentry(axios);

const container = document.getElementById("root");
const root = createRoot(container);

const uniqueIdentifier = uuidv4();

root.render(
  <React.StrictMode>
    <App version={uniqueIdentifier} />
  </React.StrictMode>
);
